import React from "react"
import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import Loading from "../../components/Loading/Loading"
import {getByBankId} from "../../resources/bankSettings"
import PaymentRules from "./PaymentRules"

export default function PaymentRulesForBank({bankId}: {bankId: string}) {
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const bankSettingsAsync = useAsyncResult(() => getByBankId(accessToken, bankId), [refreshToken, bankId])

	return (
		<AsyncResultComponent asyncResult={bankSettingsAsync} pendingComponent={<Loading />}>
			{({value: bankSettings}) => {
				if (!bankSettings) {
					return <p className="has-text-grey">Bank settings not found for this bank.</p>
				}
				return <PaymentRules bankSettings={bankSettings} refresh={refresh} />
			}}
		</AsyncResultComponent>
	)
}
